/**
 * Displays a preview version of the employer profile
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DefaultLayout from '../layout/Default';

import AllProfilesCollection from './AllProfilesCollection';
import {
    fetchAllCompanies,
    searchByName,
    PAGE_SIZE,
    ORDER,
} from './actions/allProfilesActions';
import analytics, * as trackingTypes from '../../actions/analyticsActions';

const MIN_SEARCH_LEN = 2;

export class AllProfiles extends React.PureComponent {
    static propTypes = {
        error: PropTypes.bool,
        history: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        loaded: PropTypes.bool,
        totalCount: PropTypes.number.isRequired,
        companies: PropTypes.array.isRequired,
        dispatch: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.dispatch(analytics(trackingTypes.VIEW_PROFILE_LIST));
        if (!this.props.loaded) {
            AllProfiles.fetchData(
                { dispatch: this.props.dispatch },
                null,
                this.props.match.params
            );
        }
    }

    componentDidUpdate(prevProps) {
        const {
            match: { params },
            dispatch,
        } = this.props;
        if (params.page !== prevProps.match.params.page) {
            AllProfiles.fetchData({ dispatch }, null, params);
        }
    }

    static fetchData({ dispatch }, _, params) {
        const pageNum = AllProfiles.parsePageNum(params.page);
        const offset = (pageNum - 1) * PAGE_SIZE;
        return dispatch(
            fetchAllCompanies({
                limit: PAGE_SIZE,
                offset,
                order: ORDER,
            })
        );
    }

    static parsePageNum(str) {
        return parseInt(str, 10) || 1;
    }

    onSearchInputChange = (e) => {
        const name = e.target.value;
        if (name.length >= MIN_SEARCH_LEN) {
            this.doSearch(name);
        } else if (name.length === 0) {
            this.props.dispatch(fetchAllCompanies({ limit: PAGE_SIZE }));
        }
    };

    doSearch = (name) => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.props.dispatch(searchByName({ name }));
        }, 250);
    };

    render() {
        return (
            <DefaultLayout>
                <AllProfilesCollection
                    companies={this.props.companies}
                    error={this.props.error}
                    loaded={this.props.loaded}
                    onSearchInputChange={this.onSearchInputChange}
                    pageNum={AllProfiles.parsePageNum(
                        this.props.match.params.page
                    )}
                    pageSize={PAGE_SIZE}
                    totalCount={this.props.totalCount}
                />
            </DefaultLayout>
        );
    }
}

export default connect(({ allProfiles }) => allProfiles)(AllProfiles);
